import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../common/AuthContext';
import { authFetch } from '../common/authFetch';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ActiveRoomIcon = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useAuth();
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!isAuthenticated) {
            setCount(0);
            return;
        }

        const fetchCount = async () => {
            try {
                const response = await authFetch(`${API_URL}/api/v1/studyrooms/count`);
                const data = await response.json();
                if (data.success) {
                    setCount(data.count);
                }
            } catch (error) {
                // silent fail
            }
        };

        fetchCount();
        // 60초마다 갱신
        const interval = setInterval(fetchCount, 60000);
        return () => clearInterval(interval);
    }, [isAuthenticated, location.pathname]);

    if (!isAuthenticated || count === 0) return null;

    return (
        <div
            className="active-room-icon"
            onClick={() => navigate('/studyroom')}
            title={t('studyroom.active.tooltip')}
        >
            <span className="active-room-icon-emoji">&#x1F4D6;</span>
            <span className="active-room-badge">{count}</span>
        </div>
    );
};

export default ActiveRoomIcon;
